import { Outlet } from "react-router"
import { styled } from "@mui/material/styles"
import Box from "@mui/material/Box"
import Container from "@mui/material/Container"

import Nav from "./nav"
import FullHeight from "../../components/fullHeight"

const Back = styled(Box)(({ theme }) => ({
  background: "#fff",
  [theme.breakpoints.up("sm")]: {
    background: `linear-gradient(to right, transparent 50%, ${theme.palette.grey[100]} 50%)`
  }
}))

export default function ResourcesOutlet() {
  return (
    <Back>
      <Container maxWidth="lg" sx={{ display: "flex" }}>
        <FullHeight
          minMode
          sx={{
            bgcolor: "common.white",
            flexGrow: "1",
            pr: { xs: 0, sm: 8 },
            pt: { xs: 2, sm: 5 },
            pb: 20,
            boxSizing: "border-box"
          }}
          component="article"
        >
          <Outlet />
        </FullHeight>
        <Nav />
      </Container>
    </Back>
  )
}
